<template>
  <div>
    <ValidationProvider :rules="rules" v-slot="{ errors, valid }" :name="errorLabelText">
      <b-field :label="label" :type="{'is-danger': errors.length }" :message="errors[0]">
        <multiselect
          v-model="data"
          deselect-label="Must be selected"
          track-by="id"
          label="label"
          placeholder="Select a Value"
          :options="options"
          :searchable="searchable"
          :allow-empty="allowEmpty"
          @select="(option,id) => handleSelect(option)"
        >
          <template slot="singleLabel" slot-scope="{ option }">{{ option.label }}</template>
        </multiselect>
      </b-field>
    </ValidationProvider>
  </div>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import Multiselect from "vue-multiselect";

export default {
  name: "MultiSelectInputWithValidation",

  props: {
    rules: { type: String, required: true },
    model: { type: String | Boolean },
    label: { type: String, default: "" },
    vuexKey: { type: String, required: true },
    name: { type: String, required: true },
    errorLabel: { type: String },
    placeholder: { type: String, required: true },
    options: { type: Array, required: true },
    allowEmpty: { type: Boolean, default: false },
    searchable: { type: Boolean, default: true }
  },

  components: {
    ValidationObserver,
    Multiselect
  },

  data() {
    return {
      data: this.model
    };
  },

  methods: {
    handleSelect: function(option) {
      this.$emit("input", { key: this.vuexKey, value: option.value });
    }
  },

  computed: {
    /**
     * Determine the text to be used as the field name when displaying error messages
     */
    errorLabelText() {
      if (this.errorLabel) {
        return this.errorLabel;
      }

      return this.name;
    }
  }
};
</script>
